import emitter from 'element-ui/src/mixins/emitter'
export default {
    mixins: [emitter],
    props: {},
    components: {},
    data() {
        return {
            emphasesCategory: ''
        }
    },
    computed: {

    },
    methods: {
        generateProjectChartsData() {},
        generateRiskChartsData() {},
        generateBusinessChartsData() {}
    },
    created() {},
    mounted() {}
}